import {Modal} from 'react-bootstrap';
import YouTubeShorts from '../Common/YouTubeShorts';
 

const  YoutubeVideoModal = ({videoId,modalShow,onClose}) => {
 return (
    <Modal  show={modalShow} onHide={onClose} className='quick-view-modal quick-yt-modal'>
      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}>
        <i className="icon feather icon-x"></i>
      </button>
      <Modal.Body> 
      <div className="row g-xl-4 g-3">
        <div className="col-xl-6 col-md-6"> 
              <div className="bg-image promo-img mr-3">
                <YouTubeShorts videoId={videoId} />
                <p className="yt-price-disclaimer"> Note: Prices mentioned in this video may differ from current website prices due to updates or promotions. Please refer to the product listings above for the most accurate pricing."</p>

              </div>
              </div>
              <div className="col-xl-6 col-md-6"> 

              <div className="videoModalBox content-text  align-item-stretch">
                <div className=""> 
                    <h3 className="mb-3 line title">🔔 Follow Us on Social Media 🔔 Never Miss a Deal!</h3>
                    

                    <p> <b>📢 Stay Updated with Our Daily Offers!</b></p>


                    <p>Our exclusive daily offers change every day! To stay ahead and grab the best discounts, follow us on our social media accounts. 📲</p>

                    <p><b>💡 Why follow us?</b></p>
                    <ul className='text-left'>
                      <li> ✅ Get real-time updates on special promotions 🎉</li>
                      <li> ✅ Be the first to know about flash sales ⚡</li>
                      <li> ✅ Enjoy exclusive social media-only discounts 💰</li>
                      </ul>

                    <p>👉 Don't miss out! Follow us today and save more every day! 🚀</p>
                    <h3 className="mb-3 line title"><i className="fab fa-instagram"></i> Instagram</h3>
                   <p className='text-center'> <a className="main-color" href="https://www.instagram.com/anuughacollections" target="_blank" rel="noopener noreferrer">https://www.instagram.com/anuughacollections</a> </p>

                    <h3 className="mb-3 line title"><i className="fab fa-youtube"></i> Youtube</h3>
                    <p className='text-center'><a className="main-color" href="https://www.youtube.com/@anuughacollections" target="_blank" rel="noopener noreferrer">https://www.youtube.com/@anuughacollections</a> </p>

                </div>
              </div> 
              </div> 
              </div> 
          
      </Modal.Body> 
    </Modal>
      
  );
}

export default YoutubeVideoModal;

 
